module.exports = __webpack_public_path__ + "img/cyanBg.b7712624.png";